import React from 'react';

function Table(props) {
  return (
    <div className='table_responsive_wrapper'>
      <div className='table-responsive'>
        <table className='table_white_bg table case-study-heading-wrap'>
          {props.children}
        </table>
      </div>
    </div>
  );
}

export default Table;



// WEBPACK FOOTER //
// ./src/views/CFA3/Cfa3EssayQuestions/Layout/Table.jsx